import { fetch } from 'utils/api';

export function api_getPremiumContentSources() {
  return fetch({
    url: '/premium_content/sources',
    dataType: 'PremiumContent',
    method: 'GET'
  });
}
